import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import NoSsr from '@material-ui/core/NoSsr';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import InBound from './inbound';
import OutBound from './outbound';
import Transfer from './transfer';
import Request from './request';
import RequestIN from './requestin';
import Discrepancy from './discrepancy';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

function LinkTab(props) {
  return <Tab component="a" onClick={event => event.preventDefault()} {...props} />;
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

class NavTabs extends React.Component {
  state = {
    value: 0,
    partcodeOption: [],
    parts: []
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <NoSsr>
        <div className={classes.root}>
          <AppBar position="static">
            <Tabs variant="fullWidth" value={value} onChange={this.handleChange}>
              <LinkTab label="Stock In" href="page1" />
              <LinkTab label="Stock Out" href="page2" />
              <LinkTab label="Request Out" href="page3" />
              <LinkTab label="Request In" href="page4" />
              <LinkTab label="TRANSFER" href="page5" />
              <LinkTab label="Shortage" href="page6" />
            </Tabs>
          </AppBar>
          {value === 0 && <InBound selectedBranch={this.props.selectedBranch}
                            stockinview={this.props.stockinview}
                            stockinedit={this.props.stockinedit} menuPermission={this.props.menuPermission}
                            shortageview={this.props.shortageview}
                            shortageedit={this.props.shortageedit} />}
          {value === 1 && <OutBound selectedBranch={this.props.selectedBranch}
                            stockoutview={this.props.stockoutview} menuPermission={this.props.menuPermission}
                            stockoutedit={this.props.stockoutedit}/>}
          {value === 2 && <RequestIN branchOptions={this.props.branchOptions}
                            selectedBranch={this.props.selectedBranch}
                            display={'none'} menuPermission={this.props.menuPermission}
                            stocktransferedit={this.props.stocktransferedit}
                            buttonName={'REQUEST'} partcodeOption={this.state.partcodeOption} />}
          {value === 3 && <Request branchOptions={this.props.branchOptions}
                            selectedBranch={this.props.selectedBranch} menuPermission={this.props.menuPermission}
                            stocktransferedit={this.props.stocktransferedit}
                            display={'show'}
                            buttonName={'REQUEST'} partcodeOption={this.state.partcodeOption} />}
          {value === 4 && <Transfer branchOptions={this.props.branchOptions}
                            selectedBranch={this.props.selectedBranch} menuPermission={this.props.menuPermission}
                            stocktransferedit={this.props.stocktransferedit}
                            buttonName={'SUBMIT'} partcodeOption={this.state.partcodeOption} />}
          {value === 5 && <Discrepancy selectedBranch={this.props.selectedBranch}
                            shortageview={this.props.shortageview} menuPermission={this.props.menuPermission}
                            shortageedit={this.props.shortageedit} />}
        </div>
        <Loading load={this.state.load} message={this.state.message} />
      </NoSsr>
    );
  }
}

NavTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavTabs);
